import { Box } from '@material-ui/core';
import Picker from 'component/ios_picker/iosPicker';
import { useEffect, useState } from 'react';
import './style.scss';

interface IMultiplePickerProps {
    optionGroups: {
        firstColumnOptions: any;
        secondColumnOptions: any;
    };
    valueGroup: {
        firstColumnValue: string;
        secondColumnValue: string;
    };
    onChange(selectedOptions): void;
}

export const MultipleiOSPicker = (props: IMultiplePickerProps) => {
    const [isChanging, setIsChanging] = useState(false);
    const [firstValue, setFirstValue] = useState<any>(undefined);
    const [secondValue, setSecondValue] = useState<any>(undefined);

    useEffect(() => {
        setFirstValue({ value: props.valueGroup.firstColumnValue, id: '' });
        setSecondValue({ value: props.valueGroup.secondColumnValue, id: '' });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (firstValue && secondValue && isChanging) {
            props.onChange([firstValue, secondValue]);
            setIsChanging(false);
        }
    }, [firstValue, secondValue, isChanging, props]);

    return (
        <Box className="multipleiOSPicker" display={'flex'} flexDirection={'row'} width="100%">
            <Picker
                optionGroups={{
                    name: props.optionGroups.firstColumnOptions,
                }}
                valueGroups={{
                    name: props.valueGroup.firstColumnValue,
                }}
                onChange={(name, value, selectedOption) => {
                    if (selectedOption) {
                        setFirstValue(selectedOption);
                        setIsChanging(true);
                    }
                }}
            />
            <Box className="multipleiOSPickerRightColumn" width={'100%'}>
                <Picker
                    optionGroups={{
                        name: props.optionGroups.secondColumnOptions,
                    }}
                    valueGroups={{
                        name: props.valueGroup.secondColumnValue,
                    }}
                    onChange={(name, value, selectedOption) => {
                        if (selectedOption) {
                            setSecondValue(selectedOption);
                            setIsChanging(true);
                        }
                    }}
                />
            </Box>
        </Box>
    );
};
